import type { FaireProductEntity } from "../../entity_types/product";

export const p_nmfeufecr5: FaireProductEntity = {
  token: "p_nmfeufecr5",
  type: "product",
  name: "Jack-O-Lantern Little Notes® | Halloween mini notes",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4d6d36af638764137a61529578cbcd8c9e5ed3e77535a87cc71c129c7990e7fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/122c34dc4ce63a12b1fc02021c7b52ebc99af9448da286e8a3f79299d24e68b0.jpeg",
    "https://cdn.faire.com/fastly/dca3ade7a388f4609903744421ad0df5981171599d3990e568d873166a12f704.jpeg",
    "https://cdn.faire.com/fastly/92202b6e136f86c92da6abb420e74b14f58b64cdb54c2c7534d7ca295c89cfcf.jpeg",
  ],
  priceDollars: 7,
  description:
    "Get spooky with Jack-O-Lantern Little Notes®, perfect Halloween mini notes for boo bags and non-candy treats. Featuring cute pumpkins, bats, and festive fall fun, these notes are ideal for Halloween party favors, school celebrations, and adding a playful touch to your trick-or-treat goodies. Great for kids, teachers, and Halloween lovers!\n\nLittle Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:22.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
